// Snaps a bag quantity input back to the quantity the server actually
// applied. The server clamps nonsense values (0, -1, "abc") to a real
// quantity, but when the clamp results in no data change LiveView sends no
// diff, so the stale text would sit in the focused input forever. The
// LiveView pushes "bag-qty-sync" with the raw submitted value and the
// effective quantity; the input only rewrites itself when it still shows
// exactly what was submitted, so it never clobbers continued typing.
export default BagQtySync = {
  mounted() {
    this.handleEvent("bag-qty-sync", ({ id, raw, qty }) => {
      if (this.el.dataset.lineItemId !== id) return;
      if (this.el.value !== raw) return;

      this.el.value = qty;
    });
  },
};
